export const MAX_WHOLE_KRW_AMOUNT = 99_999_999;
export const MAX_WHOLE_QUANTITY = 999_999;
//# sourceMappingURL=input-limits.js.map